import {Fragment} from 'react'

import PropTypes from 'prop-types'

import AlertOutlineIcon from '@adv-mt/mt-svg-icons/lib/AlertOutline'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {useGetInsuranceInfoContent} from '../../hooks/useGetInsuranceInfoContent.js'
import {PanelFinancingModalInsuranceLink} from './PanelFinancingModalInsuranceLink.js'

export const PanelFinancingModalInsuranceInfo = ({insuranceId}) => {
  const modalContent = useGetInsuranceInfoContent(insuranceId)

  const hasModalInfo = modalContent?.modalInfo.length > 0

  return (
    <>
      <div className="mt-PanelFinancing-modalIsuranceInfo">
        <div className={'mt-PanelFinancing-captionText'}>{modalContent.captionText}</div>
        {hasModalInfo &&
          modalContent.modalInfo.map((itemsByInsurance, i) => (
            <Fragment key={`${i}-${itemsByInsurance.title}`}>
              <div className={'mt-PanelFinancing-title'}>
                <TitleBasic as={titleBasicTags.h1} size={titleBasicSizes.m} title={itemsByInsurance.title} />
              </div>
              {itemsByInsurance.description.map((item, j) => (
                <p className="mt-PanelFinancing-modalIsuranceInfoDescription" key={`${j}-${item}`}>
                  {item}
                </p>
              ))}
              <p className="mt-PanelFinancing-modalInsuranceInfoList">{itemsByInsurance.listTitle}</p>
              {itemsByInsurance.itemsList.map(({icon: Icon, title = '', value = ''}, k) => (
                <div className="mt-PanelFinancing-modalInsuranceInfoListItem" key={`${k}-${title}`}>
                  <Icon />
                  <div className="mt-PanelFinancing-modalInsuranceInfoListText">
                    <TitleBasic as={titleBasicTags.h6} size={titleBasicSizes.xs} title={title} />
                    <span>{value}</span>
                  </div>
                </div>
              ))}
              <div className="mt-PanelFinancing-modalInsuranceImportantInfo">
                <AlertOutlineIcon size="medium" />
                <div className="mt-PanelFinancing-modalInsuranceImportantInfoText">
                  <TitleBasic
                    as={titleBasicTags.h6}
                    size={titleBasicSizes.xs}
                    title={itemsByInsurance.importantInfoTitle}
                  />
                  {itemsByInsurance.importantInfo.map(item => (
                    <p>{item}</p>
                  ))}
                </div>
              </div>
            </Fragment>
          ))}
      </div>
      <PanelFinancingModalInsuranceLink insuranceId={insuranceId} />
    </>
  )
}

PanelFinancingModalInsuranceInfo.propTypes = {
  insuranceId: PropTypes.string
}
